import React, { Component } from 'react'

import MapChart from 'modules/Charts/Map/MapChart'
import ContentChartTitle from 'modules/Content/ContentChart/ContentChartTitle'
import ContentChartFooter from 'modules/Content/ContentChart/ContentChartFooter'
import ContentDateModal from 'modules/Content/ContentChart/ContentDateModal'
import PanelRowValuesAdapter from 'modules/Charts/PanelRow/PanelRowValues/PanelRowValuesAdapter'

// import QueryTools from 'utils/queries/queryTools'
import API from 'utils/api/api'
// import APIURL from 'utils/api/urls'
import API_V1_URL from 'utils/api/urls_v1'
import DataTools from 'utils/dataTools'
import DateTools from 'utils/dates/dateTools'
// import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'


const MINIMUM_MAP_COVERAGE = 0.15; //percentage 2.0/201;

class MapChartContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showLegend: true,
      showByGender: false,
      showTable: false,
      showModal: false,
      expanded: false,
      startingYear: 0,
      endingYear: 0,
      latestCoveredYear: 0,
      minYear: 0,
      maxYear: 0,
      chartRef: null,
      femaleChartRef: null,
      maleChartRef: null,
      indicatorData: {},
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    let selectedRegionId = this.props.selectedRegionId
    let indicator = this.props.indicator

    let geo = [
      selectedRegionId
    ];
    const regionsData = this.props.regionsData;
    const benchmarkRegionIds = regionsData.map(o => o["id"]);
    benchmarkRegionIds.forEach((geo_id) => {
      if (geo_id !== selectedRegionId) {
        geo.push(geo_id);
      }
    });


    API.getQuery( API_V1_URL.getIndicatorData({ indicator, geo }) )
      .then( values => {
        let data = values.data;

        let availableTimes = DataTools.uniquePropertyValues( data, "time" ).sort( DataTools.descending );

        // console.log( availableTimes );
        // minimum: two regions
        let latestSet = PanelRowValuesAdapter.firstComparableSet(data, benchmarkRegionIds, availableTimes, MINIMUM_MAP_COVERAGE, "geo");
        let max = DateTools.getYearFromDateString( latestSet[0].time );
        let min = DateTools.getYearFromDateString( DataTools.arrayAt( availableTimes, -1 ) );
        // console.log( min, max );
        return {min, max};
      })
    // let query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)
    // API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query }))
    //   .then(data => IndicatorTools.getIndicatorEvolutionData(data))
    //   .then(indicatorEvolutionData => IndicatorTools.getMaxAndMinYearFromIndicator(indicatorEvolutionData))
      .then(({ min, max }) => {
        if (max - 10 >= min) min = max - 10
        this.setState({ minYear: min, maxYear: max, startingYear: min, endingYear: max, loading: false, error: false })
      })
      .catch(reason => {
        this.setState({ loading: false, error: true })
      })
    let indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0]
    this.setState({
      indicatorData
    })
  }

  functionSet() {
    const chartRef = this.state.chartRef
    const femaleChartRef = this.state.femaleChartRef
    const maleChartRef = this.state.maleChartRef

    let shouldShowLegend = this.state.showLegend
    const showLegend = () => {
      shouldShowLegend = !shouldShowLegend
      chartRef.current.chart.legend.update({
        enabled: shouldShowLegend
      })
      this.setState({ showLegend: shouldShowLegend })
    }
    let shouldShowByGender = this.state.showByGender
    const showByGender = () => {
      shouldShowByGender = !shouldShowByGender
      this.setState({ showByGender: shouldShowByGender })
    }
    const showTable = shouldShow => {
      this.setState({ showTable: shouldShow })
    }

    const modalFunctions = () => {
      const setDateRange = ({ startingYear, endingYear }) => {
        this.setState({
          startingYear,
          endingYear
        })
      }
      const openModal = () => {
        this.setState({
          showModal: true
        })
      }
      const closeModal = () => {
        this.setState({
          showModal: false
        })
      }

      return {
        setDateRange,
        openModal,
        closeModal
      }
    }

    const exportChart = (fileType, gender) => {
      let chart
      let fileName
      if (this.state.showByGender) {
        if (gender === 'Female') {
          chart = femaleChartRef.current.getChart()
          fileName = 'Female - ' + this.state.indicatorData.name
        } else {
          chart = maleChartRef.current.getChart()
          fileName = 'Male - ' + this.state.indicatorData.name
        }
      } else {
        chart = chartRef.current.getChart()
        fileName = this.state.indicatorData.name
      }
      let optionsToExport = {
        filename: fileName
      }

      if (fileType === 'CSV') {
        const csv = this.composeCSV(chart)
        const hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = fileName + '.csv'
        hiddenElement.click()
      } else {
        switch (fileType) {
          case 'PNG':
            optionsToExport.type = 'image/png'
            break
          case 'JPEG':
            optionsToExport.type = 'image/jpeg'
            break
          case 'PDF':
            optionsToExport.type = 'application/pdf'
            break
          case 'SVG':
            optionsToExport.type = 'image/svg+xml'
            break
          default:
            optionsToExport.type = 'image/png'
            break
        }
        chart.exportChart(optionsToExport)
      }
    }
    const expandChart = () => {
      const shouldExpand = !this.state.expanded

      if (shouldExpand) {
        document.getElementsByTagName('html')[0].classList.add('ork-no-scroll')
      } else {
        document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
      }
      this.setState({ expanded: shouldExpand })
    }

    return {
      showLegend,
      showByGender,
      showTable,
      modalFunctions,
      exportChart,
      expandChart
    }
  }

  composeCSV(chart) {
    const data = chart.series[0].data
    let csv = '"Region Name", "Values"\n'
    data.forEach((item, index) => {
      if (item.regionName !== undefined && index !== 0) {
        csv = csv + `${item.regionName.replace(',', ' ')},${item.value}\n`
      }
    })
    return csv
  }

  getRef = ref => {
    this.setState({ chartRef: ref })
  }

  getFemaleRef = ref => {
    this.setState({ femaleChartRef: ref })
  }

  getMaleRef = ref => {
    this.setState({ maleChartRef: ref })
  }

  renderMap = (generalRegionsData, regionsToShow) => {
    let renderingMap = null
    if (this.state.showByGender) {
      const indicatorMale = this.state.indicatorData.relationships.sexMale
      const indicatorFemale = this.state.indicatorData.relationships.sexFemale
      renderingMap = (
        <div className="row">
          <div className="col-sm-6">
            <MapChart
              generalRegionsData={JSON.stringify(generalRegionsData)}
              regionsToShow={JSON.stringify(regionsToShow)}
              indicator={indicatorFemale}
              gender={'Female'}
              year={this.state.endingYear}
              selectedRegionId={this.props.selectedRegionId}
              indicatorData={this.state.indicatorData}
              expanded={this.state.expanded}
              showLegend={this.state.showLegend}
              fn={this.getFemaleRef}
            />
          </div>
          <div className="col-sm-6">
            <MapChart
              generalRegionsData={JSON.stringify(generalRegionsData)}
              regionsToShow={JSON.stringify(regionsToShow)}
              indicator={indicatorMale}
              gender={'Male'}
              year={this.state.endingYear}
              selectedRegionId={this.props.selectedRegionId}
              indicatorData={this.state.indicatorData}
              expanded={this.state.expanded}
              showLegend={this.state.showLegend}
              fn={this.getMaleRef}
            />
          </div>
        </div>
      )
    } else {
      renderingMap = (
        <MapChart
          generalRegionsData={JSON.stringify(generalRegionsData)}
          regionsToShow={JSON.stringify(regionsToShow)}
          indicator={this.props.indicator}
          gender={'Total'}
          year={this.state.endingYear}
          selectedRegionId={this.props.selectedRegionId}
          indicatorData={this.state.indicatorData}
          expanded={this.state.expanded}
          showLegend={this.state.showLegend}
          fn={this.getRef}
        />
      )
    }
    return renderingMap
  }

  renderIfAllOK() {
    let renderingComponent = null
    if (this.state.error) {
      renderingComponent = <Error />
    } else if (this.state.loading) {
      renderingComponent = <Loading />
    } else {
      let comparative
      if (this.props.otherRegionsFilter !== undefined && this.props.otherRegionsFilter.length !== 0) {
        comparative = this.props.otherRegionsFilter
      } else {
        comparative = {}
      }
      let { regionsData, referenceRegionsData, sameCountryRegionsData } = this.props
      let generalRegionsData = {
        regionsData,
        referenceRegionsData,
        sameCountryRegionsData,
        comparative
      }
      let regionsToShow = {
        allRegionsFilter: this.props.allRegionsFilter,
        referenceRegionsFilter: this.props.referenceRegionsFilter,
        sameCountryRegionsFilter: this.props.sameCountryRegionsFilter,
        otherRegionsFilter: comparative
      }
      renderingComponent = (
        <div className="col-lg-6">
          <div className={`panel panel-default ${this.state.expanded ? 'panel-expanded' : ''}`}>
            <ContentChartTitle indicator={this.props.indicator} layer={this.props.layer} chartType={'map'} />
            <div className="panel-body">{this.renderMap(generalRegionsData, regionsToShow)}</div>
            <ContentChartFooter
              fn={this.functionSet()}
              indicatorData={this.state.indicatorData}
              expanded={this.state.expanded}
              chartType={'map'}
              showByGender={this.state.showByGender}
            />
          </div>
          <ContentDateModal
            show={this.state.showModal}
            fn={this.functionSet().modalFunctions()}
            startingYear={this.state.startingYear}
            endingYear={this.state.endingYear}
            minYear={this.state.minYear}
            maxYear={this.state.maxYear}
            multiple={false}
          />
        </div>
      )
    }
    return renderingComponent
  }

  render() {
    return <div>{this.renderIfAllOK()}</div>
  }
}

export default MapChartContainer



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChartContainer/MapChartContainer.jsx